import { Button } from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import { Icon, jnjFilter } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { mdiTune } from "@mdi/js";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentRefinements, UseCurrentRefinementsProps } from "react-instantsearch";

import style from "./style.module.scss";

interface AlgoliaFilterMobileFiltersButtonProps extends UseCurrentRefinementsProps {
    setShowFiltersModal: Dispatch<SetStateAction<boolean>>;
}

/**
 * TODO: Rebranding: Remove after the rebranding is done
 */
export const AlgoliaFilterMobileFiltersButton = (props: AlgoliaFilterMobileFiltersButtonProps): JSX.Element => {
    const { setShowFiltersModal } = props;
    const { t } = useTranslation();
    const { items } = useCurrentRefinements(props);
    const { jnjFullBranded } = useJnjBranding();

    let numberOfAppliedFilters = 0;
    items.forEach((item: unknown) => {
        numberOfAppliedFilters += item?.refinements?.length;
    });

    return (
        <div className={style["filter-modal-button"]}>
            <Button
                color={jnjFullBranded ? "primary" : "white"}
                variant={jnjFullBranded ? "outlined" : undefined}
                fullWidth={true}
                onClick={() => setShowFiltersModal(true)}
                data-test-id="Filters"
                size={jnjFullBranded ? "small" : "medium"}
            >
                <Typography
                    color={jnjFullBranded ? "primary-general" : "primary"}
                    size={jnjFullBranded ? undefined : "m"}
                >
                    <Icon
                        color="inherit"
                        icon={jnjFullBranded ? jnjFilter : mdiTune}
                        type={jnjFullBranded ? "jnj" : "mdi"}
                        className={jnjFullBranded ? style.icon : undefined}
                    />
                    <span data-test-id="Counter">
                        {t("Filters", { ns: "common" })} {numberOfAppliedFilters > 0 && `(${numberOfAppliedFilters})`}
                    </span>
                </Typography>
            </Button>
        </div>
    );
};

export default AlgoliaFilterMobileFiltersButton;
